import { create } from 'zustand';

const loadFromStorage = () => {
    try {
        const token = localStorage.getItem('token');
        const refreshToken = localStorage.getItem('refreshToken');
        const userJson = localStorage.getItem('user');
        const user = userJson ? JSON.parse(userJson) : null;

        return {
            user,
            token,
            refreshToken,
            isAuthenticated: !!token && !!user,
        };
    } catch {
        return {
            user: null,
            token: null,
            refreshToken: null,
            isAuthenticated: false,
        };
    }
};

const initialState = loadFromStorage();

export const useAuthStore = create((set) => ({
    ...initialState,

    login: ({ user, access_token, refresh_token, refresh_token_expires_at }) => {
        localStorage.setItem('token', access_token);
        localStorage.setItem('refreshToken', refresh_token);
        localStorage.setItem(
            'user',
            JSON.stringify(user),
        );
        if (refresh_token_expires_at) {
            localStorage.setItem('refreshTokenExpiresAt', String(refresh_token_expires_at));
        }

        set({
            user,
            token: access_token,
            refreshToken: refresh_token,
            isAuthenticated: true,
        });
    },

    updateToken: (newToken, newRefreshToken) => {
        localStorage.setItem('token', newToken);
        if (newRefreshToken) {
            localStorage.setItem('refreshToken', newRefreshToken);
        }
        set((state) => ({
            token: newToken,
            refreshToken: newRefreshToken || state.refreshToken,
        }));
    },

    logout: () => {
        localStorage.removeItem('token');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('user');
        localStorage.removeItem('refreshTokenExpiresAt');
        localStorage.removeItem('expiry_banner_dismissed');

        set({
            user: null,
            token: null,
            refreshToken: null,
            isAuthenticated: false,
        });
    },
}));
